"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHListMenuV3 = void 0;
const KHContainer_1 = require("../../KHContainer");
const KHListControllerV3_1 = require("./KHListControllerV3");
const KHHelperFunctions_1 = require("../../KHHelperFunctions");
class KHListMenuV3 extends KHContainer_1.KHContainer {
    /**
     * Creates a new KHListMenuV3.
     *
     * @param config The configuration object for the menu.
     */
    constructor(config) {
        var _a, _b;
        super(config.scene, config.rect.x, config.rect.y, config.rect.width, config.rect.height);
        this.controller = config.controller;
        this.controller.register(config.registrar);
        // If the scene shuts down, stop listening on the controller to 
        // prevent inputs for shadow objects.
        config.scene.events.on(Phaser.Scenes.Events.SHUTDOWN, () => {
            this.controller.unregister();
        });
        (_a = config.extraObjects) === null || _a === void 0 ? void 0 : _a.forEach(element => {
            this.add(element);
        });
        this.optionCreationCallback = config.optionCreationCallback;
        this.menuSpec = config.menuSpec;
        this.menuSpec.getOptions().forEach((value) => {
            this.addMenuOption(value);
        });
        for (let key of (0, KHHelperFunctions_1.arrayFromEnum)(KHListControllerV3_1.KHListKeyV3)) {
            const keynum = key;
            (_b = this.controller.getInput(keynum)) === null || _b === void 0 ? void 0 : _b.registerCallback('justDown', () => this.handleJustDown(keynum));
        }
    }
    destroy() {
        this.controller.unregister();
        this.controller.unregisterAllCallbacks(this);
        super.destroy();
    }
    handleJustDown(key) {
        if (!this.scene || this.scene.scene.isPaused(this.scene.scene.key) || this.scene.scene.isSleeping(this.scene.scene.key))
            return;
        switch (key) {
            case KHListControllerV3_1.KHListKeyV3.Confirm:
                this.menuSpec.confirmPressed();
                break;
            case KHListControllerV3_1.KHListKeyV3.Cancel:
                this.menuSpec.cancelPressed();
                break;
            case KHListControllerV3_1.KHListKeyV3.Left:
                this.menuSpec.leftPressed();
                break;
            case KHListControllerV3_1.KHListKeyV3.Right:
                this.menuSpec.rightPressed();
                break;
            case KHListControllerV3_1.KHListKeyV3.Up:
                this.menuSpec.upPressed();
                break;
            case KHListControllerV3_1.KHListKeyV3.Down:
                this.menuSpec.downPressed();
                break;
        }
    }
    addMenuOption(menuOption) {
        if (menuOption == null) {
            return;
        }
        const obj = {
            menuOption: menuOption,
            onPointerOver: () => this.menuSpec.setSelected(menuOption),
            onPointerOut: () => this.menuSpec.setSelected(null),
        };
        const { bounds, go } = this.optionCreationCallback(obj);
        menuOption.bounds = bounds;
        this.scene.add.existing(go);
        this.add(go);
    }
}
exports.KHListMenuV3 = KHListMenuV3;
